import { App } from '@gin-betting/core';

export const NAME = 'tournament' as const;

export const GET_TOURNAMENT_MATCHES_REQUEST = `tournament/GET_TOURNAMENT_MATCHES:REQUEST` as const;
export const GET_TOURNAMENT_MATCHES_SUCCESS = `tournament/GET_TOURNAMENT_MATCHES:SUCCESS` as const;
export const GET_TOURNAMENT_MATCHES_FAIL = `tournament/GET_TOURNAMENT_MATCHES:FAIL` as const;

export const COUNT_PER_PAGE = 20;
